import React from "react";

const HomeNotConnected = () => {
  return <div>Home</div>;
};

export default HomeNotConnected;
